type TObtainUrlByNotificationType = {
    type: string;
    lead?: string;
    conversation?: string;
};

export const obtainUrlByNotificationType = ({
    type,
    lead,
    conversation,
}: TObtainUrlByNotificationType) => {
    switch (type) {
        case 'conversation':
            return `/conversations?id=${conversation}`;
        case 'newLead':
        case 'assign':
            return `/management/leads/${lead}`;
        default:
            return '/';
    }
};
